import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

// Compact chat card for a live mutation preview (sequence building, etc.).
// The real show happens in SequencePreviewPanel; this card reopens it.
const LivePreviewBlock = observer(({ block }) => {
  const building = block.status === "building";
  const stepCount = (block.steps || []).length;

  return (
    <div
      className={`copilotLiveCard status-${block.status || "building"}`}
      onClick={() => copilotStore.openPreviewPanel(block.id)}
    >
      <div className="copilotLiveCard__icon">
        {building ? (
          <span className="copilotLiveCard__liveDot" />
        ) : (
          <i className="material-icons-outlined">
            {block.status === "failed" ? "error_outline" : "check_circle"}
          </i>
        )}
      </div>
      <div className="copilotLiveCard__meta">
        <div className="copilotLiveCard__title">{block.title}</div>
        <div className="copilotLiveCard__sub">
          {building
            ? `Building live · ${stepCount} step${stepCount === 1 ? "" : "s"} so far`
            : block.status === "failed"
            ? "Creation failed"
            : `Sequence created · ${stepCount} step${stepCount === 1 ? "" : "s"}`}
        </div>
      </div>
      <div className="copilotLiveCard__open">
        <span>{building ? "Watch live" : "View"}</span>
        <i className="material-icons-outlined">chevron_right</i>
      </div>
    </div>
  );
});

export default LivePreviewBlock;
